import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import { SCREEN_ID_LISTING_SELF_TOUR_MULTI_FAMILY } from 'client/constants/screenIds';

import { hasRoleAnonymous } from 'common/userRoles';

import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import ListingActions from 'client/actions/Listing';
import ApartmentActions from 'client/actions/Apartment';
import ApartmentBuildingActions from 'client/actions/ApartmentBuilding';

import SelfTourMultiFamilyPage from './SelfTourMultiFamilyPage';

@withTransitionHook
@withScreenId(SCREEN_ID_LISTING_SELF_TOUR_MULTI_FAMILY)
@withScrollToTop
@branch({
  listingPhotoResolution: ['listingPhotoResolution'],
  currentUser: ['currentUser'],
  listing: ['listing'],
  apartmentsByBuildingId: ['apartments', 'byBuildingId'],
  apartmentBuildingsById: ['apartments', 'apartmentBuildingsById'],
  specialDealsByApartmentBuildingId: ['apartments', 'specialDealsByApartmentBuildingId'],
})
class SelfTourMultiFamily extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Self Tour | Sunroom Rentals',
  });

  static fetchData(match, inject) {
    const listingId = parseInt(match.params.listingId, 10);

    return ListingActions.getById(inject, listingId).then(() => {
      const listing = inject.state.get(['listing']);
      if (!listing || !listing.apartmentBuildingId) {
        return;
      }

      return Promise.all([
        ApartmentActions.getByApartmentBuildingId(inject, {
          apartmentBuildingId: listing.apartmentBuildingId,
        }),
        ApartmentBuildingActions.getById(inject, {
          apartmentBuildingId: listing.apartmentBuildingId,
        }),
        ApartmentActions.getApartmentSpecialDealsByApartmentBuildingId(inject, {
          apartmentBuildingId: listing.apartmentBuildingId,
        }),
      ]);
    });
  }

  static propTypes = {
    isTransitioning: PropTypes.bool.isRequired,
    listingPhotoResolution: PropTypes.number.isRequired,
    currentUser: PropTypes.object.isRequired,
    listing: PropTypes.object,
    apartmentsByBuildingId: PropTypes.object.isRequired,
    apartmentBuildingsById: PropTypes.object.isRequired,
    specialDealsByApartmentBuildingId: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
  };

  render() {
    const {
      isTransitioning,
      listingPhotoResolution,
      currentUser,
      listing,
      apartmentsByBuildingId,
      apartmentBuildingsById,
      specialDealsByApartmentBuildingId,
      match,
      history,
      location,
      dispatch,
    } = this.props;

    if (hasRoleAnonymous(currentUser.roles)) {
      return <Redirect to={`/start?selfTouring=true&listingId=${match.params.listingId}`} />;
    }

    const apartment = listing && apartmentsByBuildingId[listing.apartmentBuildingId];
    const apartmentBuilding = listing && apartmentBuildingsById[listing.apartmentBuildingId];
    const apartmentSpecialDeals =
      listing && specialDealsByApartmentBuildingId[listing.apartmentBuildingId];

    if (isTransitioning) {
      return null;
    }

    if (!listing || !apartment || !apartmentBuilding) {
      return <Redirect to={`/listing/${match.params.listingId}`} />;
    }

    return (
      <SelfTourMultiFamilyPage
        listingPhotoResolution={listingPhotoResolution}
        apartmentSpecialDeals={apartmentSpecialDeals}
        stepId={match.params.stepId}
        currentUser={currentUser}
        listing={listing}
        apartment={apartment}
        apartmentBuilding={apartmentBuilding}
        history={history}
        location={location}
        dispatch={dispatch}
      />
    );
  }
}

SelfTourMultiFamily.displayName = 'SelfTourMultiFamily';

export default SelfTourMultiFamily;
